module.exports = __webpack_public_path__ + "img/AB.a650530a.png";